var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBarChartGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bar_chart",
    clipPath: "url(#clip0_7457_89138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.8 6.9H4.95C5.5275 6.9 6 7.3725 6 7.95V13.2C6 13.7775 5.5275 14.25 4.95 14.25H4.8C4.2225 14.25 3.75 13.7775 3.75 13.2V7.95C3.75 7.3725 4.2225 6.9 4.8 6.9ZM9 3.75C9.5775 3.75 10.05 4.2225 10.05 4.8V13.2C10.05 13.7775 9.5775 14.25 9 14.25C8.4225 14.25 7.95 13.7775 7.95 13.2V4.8C7.95 4.2225 8.4225 3.75 9 3.75ZM13.2 9.75C13.7775 9.75 14.25 10.2225 14.25 10.8V13.2C14.25 13.7775 13.7775 14.25 13.2 14.25C12.6225 14.25 12.15 13.7775 12.15 13.2V10.8C12.15 10.2225 12.6225 9.75 13.2 9.75Z",
    fill: "#AFBDC5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7457_89138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartGray);
export default __webpack_public_path__ + "static/media/bar_chart_gray.d497e0dfb2c3111eac4e5087fa200c5c.svg";
export { ForwardRef as ReactComponent };